import React, { useEffect, useState } from "react";
import "./InsufficiencyDetails.scss";
import AddInsufficiencyVendor from "./AddInsufficiencyVendor";
import { useDispatch, useSelector } from "react-redux";
import { adminInsufficientCandidateList } from "../../redux/actions/CompanyInsufficiencyAction";
// import Loader from "../Loader/Loader";
import ButtonLoader from "../Loader/ButtonLoader";
import AddInsufficiencyIdVendor from "./AddInsufficiencyIdVendor";
import { getApiClient } from "../../redux/actions/CompanyDashboardAction";
import Pagination from "../ReusableComponents/Pagination";
import FullPageLoader from "../Loader/FullPageLoader";
import ButtonSpinner from "../ReusableComponents/ButtonSpinner";
import Empty from "../Empty/Empty";

const InsufficiencyDetails = () => {
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");
  const [ActiveTab, setActiveTab] = useState("All");
  const [ExpandItem, setExpandItem] = useState(false);
  const [expandRequestNumber, setExpandRequestNumber] = useState("");
  const [candidateInfo, setCandidateInfo] = useState({});
  const [trigger, setTrigger] = useState(0);
  const [FillInsufficiencyDetails, setFillInsufficiencyDetails] =
    useState(false);
  const [fillInsufficiencyIdDetails, setFillInsufficiencyIdDetails] =
    useState(false);
  const adminInsufficientCandidateListData = useSelector(
    (state) => state.adminInsufficientCandidateList.data
  );
  const adminInsufficientCandidateListDataLoading = useSelector(
    (state) => state.adminInsufficientCandidateList.loading
  );
  const checkList = useSelector((state) => state.getApiClient.data?.data?.[0]?.service_provider_list);
  const [selectedCheck, setSelectedCheck] = useState("");

  const monthNames = {
    "01": "Jan",
    "02": "Feb",
    "03": "Mar",
    "04": "Apr",
    "05": "May",
    "06": "Jun",
    "07": "Jul",
    "08": "Aug",
    "09": "Sep",
    10: "Oct",
    11: "Nov",
    12: "Dec",
  };

  const [TotalNoOfPages, setTotalNoOfPages] = useState("");
  const [dataPerPage, setDataPerPage] = useState(25);
  const [RequestPage, setRequestPage] = useState(1);
  const totalPages = Math.ceil(TotalNoOfPages);
  let pageNumbers = [];
  const ellipsis = "...";
  const maxVisiblePages = 5;
  if (totalPages <= maxVisiblePages) {
    pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);
  } else {
    const middlePage = Math.ceil(maxVisiblePages / 2);
    const startPage = Math.max(1, RequestPage - middlePage);
    const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
    pageNumbers = Array.from(
      { length: endPage - startPage + 1 },
      (_, i) => startPage + i
    );
    if (startPage > 1) {
      pageNumbers.unshift(1, ellipsis);
    }
    if (endPage < totalPages) {
      pageNumbers.push(ellipsis, totalPages);
    }
  }


  const onCheckChange = (e) => {
    const { value } = e.target;
    setSelectedCheck(value);
  };

  const getAdminInsufficientCandidateList = () => {
    const offset = RequestPage * dataPerPage - dataPerPage;
    const clientInfoId = localStorage.getItem("client_info_id");
    const data = {
      client_info_id: clientInfoId,
      limit: dataPerPage,
      offset: offset,
      service_provider_id: selectedCheck,
      insufficient_status:
        ActiveTab === "All"
          ? "all"
          : ActiveTab === "Insufficiency"
          ? "insufficiency"
          : ActiveTab === "Fullfillment"
          ? "fullfillment"
          : ActiveTab === "Awaiting"
          ? "awaiting_approval"
          : ActiveTab === "Rejected"
          ? "rejected"
          : "all",
    };
    const successFn = (res) => {
      setTotalNoOfPages(Math.ceil(res?.total_count / dataPerPage));
    };
    const failureFn = (err) => {
      console.log(err);
    };
    dispatch(
      adminInsufficientCandidateList({
        data,
        successFn,
        failureFn,
      })
    );
  };
  const GetChecksList = () => {
    const master_id = localStorage.getItem("master_id");
    const clientInfoId = localStorage.getItem('client_info_id')
    const data = {
      'client_info_id': clientInfoId,
      'master_id': master_id,
    };
    const successFn = (response) => {
      console.log("Checks::::", response.data);
    };

    const failureFn = (error) => {
      alert(error);
    };
    dispatch(getApiClient({ data, successFn, failureFn }));
  };

  useEffect(() => {
    GetChecksList();
  }, []);
  useEffect(() => {
    setExpandRequestNumber("");
    getAdminInsufficientCandidateList();
  }, [ActiveTab, trigger, dataPerPage, RequestPage, selectedCheck]);

  const handleSwitchTab = (option) => {
    setRequestPage(1)
    setActiveTab(option)
  }

  return (
    <main className='InsufficiencyDetails'>
      <header className='Header'>
        <div className='Tabs'>
          <button
            className={ActiveTab === "All" ? "Active" : ""}
            onClick={() => {
              handleSwitchTab("All");
            }}>
            <span>All</span>
            {ActiveTab === "All" && (adminInsufficientCandidateListDataLoading ?
              <span><ButtonSpinner/></span>
              :
              <span>{adminInsufficientCandidateListData?.total_count}</span>
            )}
          </button>
          <button
            className={ActiveTab === "Insufficiency" ? "Active" : ""}
            onClick={() => {
              handleSwitchTab("Insufficiency");
            }}>
            <span>Insufficiency</span>
            {ActiveTab === "Insufficiency" && (adminInsufficientCandidateListDataLoading ?
              <span><ButtonSpinner/></span>
              :
              <span>{adminInsufficientCandidateListData?.total_count}</span>
            )}
          </button>
          <button
            className={ActiveTab === "Awaiting" ? "Active" : ""}
            onClick={() => {
              handleSwitchTab("Awaiting");
            }}>
            <span>Awaiting approval</span>
            {ActiveTab === "Awaiting" && (adminInsufficientCandidateListDataLoading ?
              <span><ButtonSpinner/></span>
              :
              <span>{adminInsufficientCandidateListData?.total_count}</span>
            )}
          </button>
          <button
            className={ActiveTab === "Rejected" ? "Active" : ""}
            onClick={() => {
              handleSwitchTab("Rejected");
            }}>
            <span>Rejected</span>
            {ActiveTab === "Rejected" && (adminInsufficientCandidateListDataLoading ?
              <span><ButtonSpinner/></span>
              :
              <span>{adminInsufficientCandidateListData?.total_count}</span>
            )}
          </button>
          <button
            className={ActiveTab === "Fullfillment" ? "Active" : ""}
            onClick={() => {
              handleSwitchTab("Fullfillment");
            }}>
            <span>Fullfillment</span>
            {ActiveTab === "Fullfillment" && (adminInsufficientCandidateListDataLoading ?
              <span><ButtonSpinner/></span>
              :
              <span>{adminInsufficientCandidateListData?.total_count}</span>
            )}
          </button>
        </div>
        <div className='FilterContainer'>
          <select onChange={onCheckChange}>
            <option disabled>Select a check</option>
            <option value=''>All</option>
            {checkList?.map((check) => (
              <option value={check?.serviceprovider_id}>
                {check?.display_name}
              </option>
            ))}
          </select>
        </div>
      </header>
      <section className='ContentContainer'>
        {adminInsufficientCandidateListDataLoading && (
          <FullPageLoader/>
        )}
        <div className='Content'>
          {(adminInsufficientCandidateListData?.data && adminInsufficientCandidateListData?.data?.length > 0) ?
            (adminInsufficientCandidateListData?.data?.map(
              (insufficiencyData) => {
                const listofChecks = Object.keys(
                  insufficiencyData.candidate_information
                );
                return (
                  <article>
                    <div
                      className='CandidateDetails'
                      onClick={() => {
                        if (
                          expandRequestNumber ===
                          insufficiencyData?.request_number
                        ) {
                          setExpandItem(!ExpandItem);
                        } else {
                          setExpandItem(true);
                          setExpandRequestNumber(
                            insufficiencyData?.request_number
                          );
                        }
                      }
                    }>
                      <span className='Name'>{insufficiencyData.full_name}</span>
                      <div className='Details'>
                        <div className='LabelValue'>
                          <span className='Label'>Job seeker ID</span>
                          <span className='Value'>
                            {insufficiencyData?.job_seeker_id}
                          </span>
                        </div>
                        <div className='LabelValue'>
                          <span className='Label'>Request Number</span>
                          <span className='Value'>
                            {insufficiencyData?.request_number}
                          </span>
                        </div>
                        <div className='LabelValue'>
                          <span className='Label'>Email ID</span>
                          <span className='Value'>
                            {insufficiencyData?.candidate_email}
                          </span>
                        </div>
                        <div className='LabelValue'>
                          <span className='Label'>Phone number</span>
                          <span className='Value'>
                            {insufficiencyData?.candidate_phone_number}
                          </span>
                        </div>
                      </div>
                      <span
                        className='InsuffCount'
                        onClick={() => {
                          if (
                            expandRequestNumber ===
                            insufficiencyData?.request_number
                          ) {
                            setExpandItem(!ExpandItem);
                          } else {
                            setExpandItem(true);
                            setExpandRequestNumber(
                              insufficiencyData?.request_number
                            );
                          }
                        }}>
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          width='1rem'
                          height='1rem'
                          viewBox='0 0 16 16'
                          fill='none'>
                          <path
                            d='M14.8147 11.9164L9.10562 2.01277C8.63311 1.19362 7.36784 1.19362 6.89609 2.01277L1.187 11.9164C0.72874 12.711 1.34225 13.6539 2.28876 13.6553H13.7129C14.6685 13.6539 15.27 12.7047 14.8155 11.9164H14.8147ZM8.00085 11.9825C7.5816 11.9825 7.23734 11.6605 7.23734 11.2667V11.0059C7.23734 10.6121 7.58085 10.2901 8.00085 10.2901C8.42086 10.2901 8.76437 10.6121 8.76437 11.0059V11.2667C8.76437 11.6598 8.42086 11.9825 8.00085 11.9825ZM8.00085 9.56938C7.5816 9.56938 7.23734 9.24734 7.23734 8.85359V5.22118C7.23734 4.82743 7.58085 4.50539 8.00085 4.50539C8.42086 4.50539 8.76437 4.82743 8.76437 5.22118V8.85359C8.76437 9.24734 8.42086 9.56938 8.00085 9.56938ZM9.76938 1.67808L15.4785 11.5818C16.2037 12.8397 15.2355 14.3577 13.7129 14.3605H2.28876C0.756491 14.3577 -0.197524 12.8326 0.523237 11.5818L6.23233 1.67808C6.99059 0.362514 9.01112 0.362514 9.76938 1.67808Z'
                            fill='#102C97'
                          />
                        </svg>
                        <span>
                          {insufficiencyData?.insufficient_comments &&
                            Object.keys(
                              insufficiencyData?.insufficient_comments[0]
                            )?.length}
                        </span>
                      </span>
                    </div>
                    <div
                      className={`ExpandedDetailWrapper ${
                        ExpandItem &&
                        expandRequestNumber === insufficiencyData?.request_number
                          ? "Show"
                          : ""
                      }`}>
                      <div className='Wrapper'>
                        {listofChecks.map((key) => {
                          const candidateInfo =
                            insufficiencyData?.candidate_information?.[key];
                          const isEducation = key === "CLIENT_1232";
                          const isEmployment =
                            key === "CLIENT_1233" || key === "CLIENT_1252";
                          const isPersinalInfo =
                            key === "CLIENT_1253" ||
                            key === "CLIENT_1250" ||
                            key === "CLIENT_1249" ||
                            key === "CLIENT_1259" ||
                            key === "CLIENT_1231";
                          const isAddress = key === "CLIENT_1251";
                          const isIdCheck =
                            key === "CLIENT_1234" ||
                            key === "CLIENT_1235" ||
                            key === "CLIENT_1236" ||
                            key === "CLIENT_1237" ||
                            key === "CLIENT_1238" ||
                            key === "CLIENT_1239" ||
                            key === "CLIENT_1241";

                          const insufficientComments =
                            insufficiencyData?.insufficient_comments?.[0]?.[key];
                          const insufficientSubcat =
                            insufficientComments &&
                            Object.keys(insufficientComments);
                          return (
                            <>
                              {insufficientSubcat && (
                                <div className='ExpandDetail'>
                                  <h3>{insufficientComments?.Display_name}</h3>
                                  {insufficientSubcat?.map(
                                    (subCat) =>
                                      subCat !== "Display_name" && (
                                        <div className='InsuffDetail'>
                                          {(isEducation || isEmployment) && (
                                            <div className='Institution'>
                                              <div className='InsDetail'>
                                                <svg
                                                  xmlns='http://www.w3.org/2000/svg'
                                                  width='24'
                                                  height='24'
                                                  viewBox='0 0 30 31'
                                                  fill='none'>
                                                  <path
                                                    d='M25.8626 11.4317H19.9062V9.02665C19.9062 8.7437 19.711 8.55507 19.418 8.55507H15.4634V7.75338C15.5611 7.75338 15.7075 7.80053 15.8052 7.80053C16.9281 7.80053 17.9045 6.99884 18.6857 7.47043C19.0274 7.65906 19.418 7.47043 19.418 7.09316V4.78241C19.418 4.64093 19.3204 4.4523 19.1739 4.40514C17.6116 3.46198 16.2446 5.06536 15.2193 4.40514C14.9264 4.16935 14.487 4.40514 14.487 4.78241V8.55507H10.5324C10.2394 8.55507 10.0441 8.7437 10.0441 9.02665V11.4317H4.08783C3.7949 11.4317 3.59961 11.6203 3.59961 11.9033V26.428C3.59961 26.711 3.7949 26.8996 4.08783 26.8996H25.9114C26.2043 26.8996 26.3996 26.711 26.3996 26.428V11.9033C26.3508 11.6675 26.1555 11.4317 25.8626 11.4317ZM15.4634 5.44262C16.6352 5.63126 17.6604 4.78241 18.4416 5.06536V6.38579C17.2698 6.19715 16.2446 7.046 15.4634 6.76305V5.44262ZM11.0206 21.7122V16.1004H14.487V21.7122H11.0206ZM15.4634 16.1004H18.9298V21.7122H15.4634V16.1004ZM18.9298 9.49823V15.1101H15.4634V9.45107H18.9298V9.49823ZM11.0206 9.49823H14.487V15.1572H11.0206V9.49823ZM4.57605 12.3749H10.0441V25.9564H4.57605V12.3749ZM11.0206 22.6554H18.9298V26.0036H17.6604V24.2116C17.6604 23.9286 17.4651 23.74 17.1722 23.74H12.7782C12.4853 23.74 12.29 23.9286 12.29 24.2116V26.0036H11.0206V22.6554ZM13.2664 26.0036V24.6832H16.684V26.0036H13.2664ZM25.3743 26.0036H19.9062V12.3749H25.3743V26.0036Z'
                                                    fill='black'
                                                  />
                                                  <path
                                                    d='M8.84456 13.6992H6.46632C6.18653 13.6992 6 13.8947 6 14.1879C6 14.4811 6.18653 14.6766 6.46632 14.6766H8.84456C9.12435 14.6766 9.31088 14.4811 9.31088 14.1879C9.31088 13.8947 9.12435 13.6992 8.84456 13.6992ZM8.84456 16.9734H6.46632C6.18653 16.9734 6 17.1689 6 17.4621C6 17.7553 6.18653 17.9508 6.46632 17.9508H8.84456C9.12435 17.9508 9.31088 17.7553 9.31088 17.4621C9.31088 17.1689 9.12435 16.9734 8.84456 16.9734ZM8.84456 20.2476H6.46632C6.18653 20.2476 6 20.4431 6 20.7363C6 21.0295 6.18653 21.225 6.46632 21.225H8.84456C9.12435 21.225 9.31088 21.0295 9.31088 20.7363C9.31088 20.4431 9.12435 20.2476 8.84456 20.2476ZM8.84456 23.5218H6.46632C6.18653 23.5218 6 23.7173 6 24.0105C6 24.3037 6.18653 24.4992 6.46632 24.4992H8.84456C9.12435 24.4992 9.31088 24.3037 9.31088 24.0105C9.31088 23.7173 9.12435 23.5218 8.84456 23.5218ZM21.1554 14.6766H23.5337C23.8135 14.6766 24 14.4811 24 14.1879C24 13.8947 23.8135 13.6992 23.5337 13.6992H21.1554C20.8756 13.6992 20.6891 13.8947 20.6891 14.1879C20.6891 14.4811 20.8756 14.6766 21.1554 14.6766ZM21.1554 17.9508H23.5337C23.8135 17.9508 24 17.7553 24 17.4621C24 17.1689 23.8135 16.9734 23.5337 16.9734H21.1554C20.8756 16.9734 20.6891 17.1689 20.6891 17.4621C20.6891 17.7553 20.8756 17.9508 21.1554 17.9508ZM21.1554 21.225H23.5337C23.8135 21.225 24 21.0295 24 20.7363C24 20.4431 23.8135 20.2476 23.5337 20.2476H21.1554C20.8756 20.2476 20.6891 20.4431 20.6891 20.7363C20.6891 21.0295 20.8756 21.225 21.1554 21.225ZM21.1554 24.4992H23.5337C23.8135 24.4992 24 24.3037 24 24.0105C24 23.7173 23.8135 23.5218 23.5337 23.5218H21.1554C20.8756 23.5218 20.6891 23.7173 20.6891 24.0105C20.6891 24.3037 20.8756 24.4992 21.1554 24.4992Z'
                                                    fill='black'
                                                  />
                                                </svg>
                                                <div className='LabelValue'>
                                                  <span className='Label'>
                                                    {isEducation
                                                      ? "Institution Name"
                                                      : isEmployment
                                                      ? "Company Name"
                                                      : ""}
                                                  </span>
                                                  <span className='Value'>
                                                    {isEducation
                                                      ? insufficientComments[
                                                          subCat
                                                        ]?.[0]?.college_name
                                                      : isEmployment
                                                      ? insufficientComments[
                                                          subCat
                                                        ]?.[0]?.company_name
                                                      : ""}
                                                  </span>
                                                </div>
                                              </div>
                                              <div className='InsDetail'>
                                                <svg
                                                  xmlns='http://www.w3.org/2000/svg'
                                                  width='24'
                                                  height='24'
                                                  viewBox='0 0 30 31'
                                                  fill='none'>
                                                  <path
                                                    d='M8.69727 20.0978C8.69727 19.5799 9.10021 19.1603 9.59727 19.1603H16.0046C16.5016 19.1603 16.9046 19.5799 16.9046 20.0978C16.9046 20.6155 16.5016 21.0353 16.0046 21.0353H9.59727C9.10021 21.0353 8.69727 20.6155 8.69727 20.0978ZM9.59727 15.6094C9.10021 15.6094 8.69727 16.029 8.69727 16.5469C8.69727 17.0646 9.10021 17.4844 9.59727 17.4844H13.1973C13.6944 17.4844 14.0973 17.0646 14.0973 16.5469C14.0973 16.029 13.6944 15.6094 13.1973 15.6094H9.59727Z'
                                                    fill='#292D32'
                                                  />
                                                  <path
                                                    fill-rule='evenodd'
                                                    clip-rule='evenodd'
                                                    d='M10.4441 5.1875C10.9412 5.1875 11.3441 5.60724 11.3441 6.125V6.4418C11.7924 6.43749 12.27 6.43749 12.7782 6.4375H16.51C17.0182 6.43749 17.4959 6.43749 17.9441 6.4418V6.125C17.9441 5.60724 18.3471 5.1875 18.8441 5.1875C19.3413 5.1875 19.7441 5.60724 19.7441 6.125V6.50346C20.0164 6.5234 20.2729 6.54935 20.5143 6.58315C21.5944 6.73442 22.5039 7.05804 23.2261 7.81044C23.9484 8.56284 24.2591 9.51017 24.4043 10.6353C24.5442 11.719 24.5442 13.0969 24.5441 14.8064V18.6697C24.5441 19.8 24.5442 20.7116 24.4801 21.447C24.4143 22.2049 24.2747 22.8671 23.9412 23.4688C23.5463 24.1814 22.9782 24.7731 22.2941 25.1845C21.7167 25.5318 21.0809 25.6771 20.3532 25.7459C19.6473 25.8125 18.7722 25.8125 17.6871 25.8125H12.7783C11.1372 25.8125 9.81439 25.8125 8.77404 25.6669C7.69391 25.5156 6.78445 25.192 6.06216 24.4396C5.33986 23.6871 5.02919 22.7399 4.88397 21.6147C4.74409 20.531 4.74412 19.1531 4.74414 17.4436V14.8064C4.74412 13.0969 4.74409 11.719 4.88397 10.6353C5.02919 9.51017 5.33986 8.56284 6.06216 7.81044C6.78445 7.05804 7.69391 6.73442 8.77404 6.58315C9.01539 6.54935 9.27193 6.5234 9.54414 6.50346V6.125C9.54414 5.60724 9.94708 5.1875 10.4441 5.1875ZM17.9441 8.31714V8.625C17.9441 9.14276 18.3471 9.5625 18.8441 9.5625C19.3413 9.5625 19.7441 9.14276 19.7441 8.625V8.38341C19.9318 8.39905 20.1081 8.41814 20.2744 8.44144C21.1549 8.56475 21.6213 8.79031 21.9533 9.13626C22.2855 9.48221 22.5019 9.96792 22.6204 10.8851C22.6427 11.0584 22.6611 11.2421 22.6761 11.4375H6.61221C6.62722 11.2421 6.64555 11.0584 6.66791 10.8851C6.7863 9.96792 7.00283 9.48221 7.33495 9.13626C7.66707 8.79031 8.13335 8.56475 9.01389 8.44144C9.18023 8.41814 9.35652 8.39905 9.54414 8.38341V8.625C9.54414 9.14276 9.94708 9.5625 10.4441 9.5625C10.9412 9.5625 11.3441 9.14276 11.3441 8.625V8.31714C11.7958 8.3127 12.2933 8.3125 12.8441 8.3125H16.4441C16.995 8.3125 17.4925 8.3127 17.9441 8.31714ZM6.54858 13.3125C6.54433 13.783 6.54414 14.3013 6.54414 14.875V17.375C6.54414 19.1693 6.54605 20.4206 6.66791 21.3649C6.7863 22.2821 7.00283 22.7677 7.33495 23.1137C7.66707 23.4597 8.13335 23.6853 9.01389 23.8086C9.92031 23.9355 11.1216 23.9375 12.8441 23.9375H17.6441C18.7823 23.9375 19.5756 23.9366 20.1907 23.8785C20.7936 23.8216 21.1362 23.7158 21.3941 23.5608C21.8046 23.3139 22.1454 22.9588 22.3824 22.5312C22.5313 22.2626 22.6329 21.9056 22.6876 21.2778C22.7433 20.637 22.7441 19.8105 22.7441 18.625V14.875C22.7441 14.3013 22.744 13.783 22.7397 13.3125H6.54858Z'
                                                    fill='#292D32'
                                                  />
                                                </svg>
                                                <div className='LabelValue'>
                                                  <span className='Label'>
                                                    Start Month
                                                  </span>
                                                  <span className='Value'>
                                                    {
                                                      monthNames[
                                                        insufficientComments[
                                                          subCat
                                                        ]?.[0]?.start_month
                                                      ]
                                                    }
                                                  </span>
                                                </div>
                                              </div>
                                              <div className='InsDetail'>
                                                <svg
                                                  xmlns='http://www.w3.org/2000/svg'
                                                  width='24'
                                                  height='24'
                                                  viewBox='0 0 30 31'
                                                  fill='none'>
                                                  <path
                                                    d='M8.69727 20.0978C8.69727 19.5799 9.10021 19.1603 9.59727 19.1603H16.0046C16.5016 19.1603 16.9046 19.5799 16.9046 20.0978C16.9046 20.6155 16.5016 21.0353 16.0046 21.0353H9.59727C9.10021 21.0353 8.69727 20.6155 8.69727 20.0978ZM9.59727 15.6094C9.10021 15.6094 8.69727 16.029 8.69727 16.5469C8.69727 17.0646 9.10021 17.4844 9.59727 17.4844H13.1973C13.6944 17.4844 14.0973 17.0646 14.0973 16.5469C14.0973 16.029 13.6944 15.6094 13.1973 15.6094H9.59727Z'
                                                    fill='#292D32'
                                                  />
                                                  <path
                                                    fill-rule='evenodd'
                                                    clip-rule='evenodd'
                                                    d='M10.4441 5.1875C10.9412 5.1875 11.3441 5.60724 11.3441 6.125V6.4418C11.7924 6.43749 12.27 6.43749 12.7782 6.4375H16.51C17.0182 6.43749 17.4959 6.43749 17.9441 6.4418V6.125C17.9441 5.60724 18.3471 5.1875 18.8441 5.1875C19.3413 5.1875 19.7441 5.60724 19.7441 6.125V6.50346C20.0164 6.5234 20.2729 6.54935 20.5143 6.58315C21.5944 6.73442 22.5039 7.05804 23.2261 7.81044C23.9484 8.56284 24.2591 9.51017 24.4043 10.6353C24.5442 11.719 24.5442 13.0969 24.5441 14.8064V18.6697C24.5441 19.8 24.5442 20.7116 24.4801 21.447C24.4143 22.2049 24.2747 22.8671 23.9412 23.4688C23.5463 24.1814 22.9782 24.7731 22.2941 25.1845C21.7167 25.5318 21.0809 25.6771 20.3532 25.7459C19.6473 25.8125 18.7722 25.8125 17.6871 25.8125H12.7783C11.1372 25.8125 9.81439 25.8125 8.77404 25.6669C7.69391 25.5156 6.78445 25.192 6.06216 24.4396C5.33986 23.6871 5.02919 22.7399 4.88397 21.6147C4.74409 20.531 4.74412 19.1531 4.74414 17.4436V14.8064C4.74412 13.0969 4.74409 11.719 4.88397 10.6353C5.02919 9.51017 5.33986 8.56284 6.06216 7.81044C6.78445 7.05804 7.69391 6.73442 8.77404 6.58315C9.01539 6.54935 9.27193 6.5234 9.54414 6.50346V6.125C9.54414 5.60724 9.94708 5.1875 10.4441 5.1875ZM17.9441 8.31714V8.625C17.9441 9.14276 18.3471 9.5625 18.8441 9.5625C19.3413 9.5625 19.7441 9.14276 19.7441 8.625V8.38341C19.9318 8.39905 20.1081 8.41814 20.2744 8.44144C21.1549 8.56475 21.6213 8.79031 21.9533 9.13626C22.2855 9.48221 22.5019 9.96792 22.6204 10.8851C22.6427 11.0584 22.6611 11.2421 22.6761 11.4375H6.61221C6.62722 11.2421 6.64555 11.0584 6.66791 10.8851C6.7863 9.96792 7.00283 9.48221 7.33495 9.13626C7.66707 8.79031 8.13335 8.56475 9.01389 8.44144C9.18023 8.41814 9.35652 8.39905 9.54414 8.38341V8.625C9.54414 9.14276 9.94708 9.5625 10.4441 9.5625C10.9412 9.5625 11.3441 9.14276 11.3441 8.625V8.31714C11.7958 8.3127 12.2933 8.3125 12.8441 8.3125H16.4441C16.995 8.3125 17.4925 8.3127 17.9441 8.31714ZM6.54858 13.3125C6.54433 13.783 6.54414 14.3013 6.54414 14.875V17.375C6.54414 19.1693 6.54605 20.4206 6.66791 21.3649C6.7863 22.2821 7.00283 22.7677 7.33495 23.1137C7.66707 23.4597 8.13335 23.6853 9.01389 23.8086C9.92031 23.9355 11.1216 23.9375 12.8441 23.9375H17.6441C18.7823 23.9375 19.5756 23.9366 20.1907 23.8785C20.7936 23.8216 21.1362 23.7158 21.3941 23.5608C21.8046 23.3139 22.1454 22.9588 22.3824 22.5312C22.5313 22.2626 22.6329 21.9056 22.6876 21.2778C22.7433 20.637 22.7441 19.8105 22.7441 18.625V14.875C22.7441 14.3013 22.744 13.783 22.7397 13.3125H6.54858Z'
                                                    fill='#292D32'
                                                  />
                                                </svg>
                                                <div className='LabelValue'>
                                                  <span className='Label'>
                                                    Start Year
                                                  </span>
                                                  <span className='Value'>
                                                    {
                                                      insufficientComments[
                                                        subCat
                                                      ]?.[0]?.start_year
                                                    }
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                          {insufficientComments[subCat]?.map(
                                            (comment, i) => (
                                              <>
                                                <div className='CommentSection'>
                                                  <div className='CommentButton'>
                                                    <div className='Comment'>
                                                      <span className='Label'>
                                                        Insufficiency Comment
                                                      </span>
                                                      <span className='Value'>
                                                        {comment?.Remark}
                                                      </span>
                                                    </div>
                                                    <div className='TimeButton'>
                                                      <span>
                                                        {
                                                          insufficientComments[
                                                            subCat
                                                          ]?.[0]?.send_time
                                                        }
                                                      </span>
                                                      <button
                                                        onClick={() => {
                                                          comment?.insufficient_status ===
                                                            "insufficiency" &&
                                                            (isEducation ||
                                                              isEmployment ||
                                                              isPersinalInfo ||
                                                              isAddress) &&
                                                            setFillInsufficiencyDetails(
                                                              true
                                                            );
                                                          comment?.insufficient_status ===
                                                            "insufficiency" &&
                                                            isIdCheck &&
                                                            setFillInsufficiencyIdDetails(
                                                              true
                                                            );
                                                          if (
                                                            isEducation ||
                                                            isEmployment
                                                          ) {
                                                            setCandidateInfo({
                                                              candidate_user_name:
                                                                insufficiencyData?.candidate_name,
                                                              serviceprovider_id:
                                                                key,
                                                              college_company_id:
                                                                insufficientComments[
                                                                  subCat
                                                                ]?.[i]?.id,
                                                            });
                                                          } else if (
                                                            isPersinalInfo ||
                                                            isAddress ||
                                                            isIdCheck
                                                          ) {
                                                            setCandidateInfo({
                                                              candidate_user_name:
                                                                insufficiencyData?.candidate_name,
                                                              serviceprovider_id:
                                                                key,
                                                              college_company_id:
                                                                "",
                                                            });
                                                          }
                                                        }}
                                                        className={
                                                          comment?.insufficient_status
                                                        }>
                                                        {comment?.insufficient_status ===
                                                        "rejected"
                                                          ? "Rejected"
                                                          : comment?.insufficient_status ===
                                                            "insufficiency"
                                                          ? "Add Details"
                                                          : comment?.insufficient_status ===
                                                            "fullfillment"
                                                          ? "Approved"
                                                          : comment?.insufficient_status ===
                                                            "awaiting_approval"
                                                          ? "Awaiting Approval"
                                                          : ""}
                                                      </button>
                                                    </div>
                                                  </div>
                                                </div>
                                              </>
                                            )
                                          )}
                                        </div>
                                      )
                                  )}
                                </div>
                              )}
                            </>
                          );
                        })}
                      </div>
                    </div>
                  </article>
                );
              })
            )
            :
            (
              <Empty/>
            )
          }
        </div>
        {(adminInsufficientCandidateListData?.data && adminInsufficientCandidateListData?.data?.length > 0) &&
          <Pagination
            currentPage={RequestPage}
            totalPages={TotalNoOfPages}
            onPageChange={(page) => setRequestPage(page)}
            dataPerPage={dataPerPage}
            setDataPerPage={setDataPerPage}
          />
        }
      </section>
      {FillInsufficiencyDetails && (
        <AddInsufficiencyVendor
          setFillInsufficiencyDetails={setFillInsufficiencyDetails}
          candidateInfo={candidateInfo}
          setTrigger={() => setTrigger(trigger + 1)}
        />
      )}
      {fillInsufficiencyIdDetails && (
        <AddInsufficiencyIdVendor
          setFillInsufficiencyDetails={setFillInsufficiencyIdDetails}
          candidateInfo={candidateInfo}
          setTrigger={() => setTrigger(trigger + 1)}
        />
      )}
    </main>
  );
};

export default InsufficiencyDetails;